import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { router } from './router';
import { useAuthStore } from './store/authStore';
import { SocketProvider } from './contexts/SocketContext';
import { FriendsProvider } from './contexts/FriendsContext';
import { useNotifications } from './hooks/useNotifications';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
});

function AppContent() {
  // Initialize notifications hook to listen for real-time notifications
  useNotifications();

  return (
    <>
      <RouterProvider router={router} />
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#363636',
            color: '#fff',
          },
        }}
      />
    </>
  );
}

function App() {
  const checkAuth = useAuthStore((state) => state.checkAuth);

  useEffect(() => {
    // Skip global auth check on callback routes — CallbackPage handles auth itself.
    // Running checkAuth() in parallel causes a race: checkAuth sets 'unauthenticated'
    // before handleAuthCallback finishes, so ProtectedRoute redirects to /login.
    const path = window.location.pathname;
    if (path.includes('/auth/callback')) {
      return;
    }
    checkAuth();
  }, [checkAuth]);

  return (
    <QueryClientProvider client={queryClient}>
      <SocketProvider>
        <FriendsProvider>
          <AppContent />
        </FriendsProvider>
      </SocketProvider>
    </QueryClientProvider>
  );
}

export default App;
